"use client"

import { Suspense } from "react"
import dynamic from "next/dynamic"

const LoginDialog = dynamic(
  () =>
    import("@/features/auth/components/login-dialog").then(
      (mod) => mod.LoginDialog
    ),
  {
    ssr: false,
  }
)

export function LoginDialogNoSSR() {
  return (
    <Suspense fallback={null}>
      <LoginDialog />
    </Suspense>
  )
}
